export default __webpack_public_path__ + "static/media/doc-admin-download.f11b00ef.svg";